import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormLabel } from 'components';

interface BlockHeaderGroupProps {
    label: string;
    value?: string;
}

const styles = {
    headerGroup: { p: 1 },
    headerLabel: { mr: 1 },
    headerValue: { overflowWrap: 'anywhere' },
};
export const BlockHeaderInfoGroup = (
    props: BlockHeaderGroupProps
): React.JSX.Element => {
    const { label, value } = props;

    return (
        <Box sx={styles.headerGroup}>
            <FormLabel text={label} />

            <Typography variant='body2' sx={styles.headerValue}>
                {value}
            </Typography>
        </Box>
    );
};
